module.exports = __webpack_public_path__ + "static/previous-navigation-poster-91141fd6edee827c67c80c0e3be945c9.png";